var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-vertical",
    { attrs: { "nav-menu-items": _vm.navMenuItems } },
    [
      _c("router-view"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "p-1",
          attrs: { slot: "breadcrumb" },
          slot: "breadcrumb",
        },
        [
          _vm.userData.role == "Student"
            ? _c("h5", { staticStyle: { "text-align": "center" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.userData.fullName) + "\n        "
                ),
                _c("br"),
                _vm._v(_vm._s(_vm.userData.className) + " \n\n      "),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }